<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Phone Number</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field>
        <mat-label>Number</mat-label>
        <input
          matInput
          autocomplete="off"
          type="text"
          formControlName="phoneNumber"
          required
          id="e7555726-9d4f-4e2a-acd9-d1492699010d"
          #phoneNumber
          />
          @if (!form.controls.phoneNumber.valid) {
            <mat-error matError>Please enter a valid phone number</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Provider</mat-label>
          <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="providerId"
            id="providerId"
            lcsStaticSelect
            [lcsSingleSelect]="providerSelect"
            [lcsStaticSelectValue]="form.get('providerId')?.value"
            required
            (search)="providerSearch($event)"
            (reset)="providerReset()"
            />
            @if (form.get('providerId')?.hasError('required')) {
              <mat-error>Provider is Required. </mat-error>
            }
            <lcs-static-select #providerSelect [displayWith]="providerDisplayWith" [autoActiveFirstOption]="false">
              @for (provider of providers; track provider) {
                <lcs-option [value]="provider">
                  {{ provider }}
                </lcs-option>
              }
            </lcs-static-select>
          </mat-form-field>
          <div class="checkbox-group">
            <mat-checkbox formControlName="isPorted" id="6b5b1961-a45f-49b8-9c55-3b8f400b403f">Ported</mat-checkbox>
            <mat-checkbox [checked]="phoneNumber?.isActive" formControlName="isActive" id="isActive"
              >Active
            </mat-checkbox>
          </div>
          <br />

          <mat-form-field>
            <mat-label>Date Ported</mat-label>
            <input
              matInput
              lcsDatepicker
              autocomplete="off"
              formControlName="datePorted"
              [lcsDatepickerPanel]="datepickerPanel"
              id="bfb0c3d9-f6a9-4482-b9fa-176259c5c4d2"
              />
              @if (form.get('datePorted')?.hasError('required')) {
                <mat-error>Date Ported is Required. </mat-error>
              }
              <lcs-datepicker-toggle matSuffix [for]="datepickerPanel"></lcs-datepicker-toggle>
              <lcs-datepicker-panel #datepickerPanel></lcs-datepicker-panel>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Account</mat-label>
              <input
                autocomplete="off"
                type="text"
                [lcsSingleSelect]="accountSel"
                ndtAccountSelect
                formControlName="account"
                id="user-account"
                [required]="form.get('isActive')?.value"
                />
                <ndt-account-select #accountSel></ndt-account-select>
                @if (form.get('account')?.hasError('required')) {
                  <mat-error>
                    Account is required on active Phone Numbers.
                  </mat-error>
                }
              </mat-form-field>
              @if (form.get('account')?.value) {
                <mat-form-field class="flex-half">
                  <mat-label>Open Extension</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    [lcsSingleSelect]="openExtensionSelect"
                    [accountId]="selectedAccountId"
                    [required]="form.get('isActive')?.value"
                    ndtExtensionSelect
                    formControlName="openExtension"
                    id="openExtension"
                    [extensionTypesToExclude]="[7]"
                    />
                    <ndt-extension-select #openExtensionSelect isIncludeEmptyOption="true"></ndt-extension-select>
                    @if (form.get('openExtension')?.hasError('required')) {
                      <mat-error>
                        Open Extension is required on active Phone Numbers.
                      </mat-error>
                    }
                  </mat-form-field>
                }

                @if (form.get('account')?.value) {
                  <mat-form-field class="flex-half">
                    <mat-label>Closed Extension</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      [lcsSingleSelect]="closedExtensionSelect"
                      [required]="form.get('isActive')?.value"
                      ndtExtensionSelect
                      [accountId]="selectedAccountId"
                      formControlName="closedExtension"
                      id="closedExtension"
                      [extensionTypesToExclude]="[7]"
                      />
                      <ndt-extension-select #closedExtensionSelect isIncludeEmptyOption="true"></ndt-extension-select>
                      @if (form.get('closedExtension')?.hasError('required')) {
                        <mat-error>
                          Closed Extension is required on active Phone Numbers.
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                </mat-dialog-content>
                <mat-dialog-actions>
                  <button type="button" title="submitAndAddAnother" (click)="onCreateAndAddAnother()" mat-stroked-button
                    >Save and Add Another</button
                    >
                    <button type="submit" title="Create" mat-raised-button color="primary" id="5a0a4d3b-af6b-461a-8538-feffa363d489">Save</button>
                  </mat-dialog-actions>
                </form>
              </lcs-loading-overlay>
